// Dependencies
import { h, Component } from 'preact';
import {connect} from 'react-redux'

// Components
import {Form, I18n} from 'components/elements' 

// Actions
import {PageActions} from 'actions'

// Style
import style from './style.less'

// Icons
import calendarIcon from "../../../assets/icons/svg/calendar.svg";
import contactIcon from "../../../assets/icons/svg/user.svg";
import reviewIcon from "../../../assets/icons/svg/review.svg";
import finishIcon from "../../../assets/icons/svg/finish.svg";


// Class Component
@Form
@connect((state)=>({
	...state
}))
export default class Steps extends Component {

    // Constructor
	constructor(){
        super()
        this.changePage = this.changePage.bind(this)
        this.getContainerClass = this.getContainerClass.bind(this)
    }

    // Methods
    changePage(page){
        if(this.props.completedPages.includes(page)){
            PageActions.set(page)
        }
    }

    getContainerClass(page){
        let classes = [style.step];

        if(this.props.page == page){
            classes.push(style.current)
        }
        
        if(this.props.completedPages.includes(page)){
            classes.push(style.completed)
        }

        if(page == 'sessions'){
            classes.push(style.left)
        }

        return classes.join(' ')
    }

    // Render Method
	render(){
        const step = (page, addConector = true) => {

            const setup = {
                timeSlots: {
                    icon: calendarIcon,
                    text: 'appointment'
                },
                collectInformation: {
                    icon: contactIcon,
                    text: 'contact'
                },
                confirmation: {
                    icon: reviewIcon,
                    text: 'review'
                },
                receipt: {
                    icon: finishIcon,
                    text: 'finish'
                }
            }

            const stepSelected = setup[page];


            const dynamicStyle = this.getContainerClass(page);

            return stepSelected ? 
                <div class={dynamicStyle}>
                    <div class={style.stepIcon}>
                        <img src={stepSelected.icon} alt={`${stepSelected.text}Icon`} />
                    </div>
                    <div class={style.stepText}>
                        <label> <I18n>{stepSelected.text}</I18n></label>
                    </div>
                    {addConector && <div class={style.connector}></div>}
                </div> 
                : null;
        }

		return (
            <div class={style.stepsContainer} style={{maxWidth: this.props.config.type == 'registration'? '500px': '700px'}}>
                {this.props.config.type != 'registration' && step("timeSlots")}
                {step("collectInformation")}
                {step("confirmation")}
                {step("receipt", false)}
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/Steps/index.js